export enum LotAddendumIncentiveApplicationMethod {
  'Highest cost first' = 0,
  'Order added' = 1
}
